var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rows
    ? _c(
        "div",
        { staticClass: "mx-auto mb-4", class: { dark: _vm.dark } },
        [
          _c("v-simple-table", {
            staticClass: "table",
            attrs: { dense: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticClass: "text-center pa-2" }, [
                            _vm._v("Numero squadre max"),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center pa-2" }, [
                            _vm._v("Prezzo"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass:
                                "text-left text--text text--lighten-2 pa-2",
                            },
                            [
                              _vm._v(
                                "\n            Equivalente circa di\n          "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.rows, function (row) {
                          return _c(
                            "tr",
                            {
                              key: row.legaDa,
                              class: { selezionato: row.selezionato },
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center pa-2",
                                  attrs: { width: "150" },
                                },
                                [_vm._v(_vm._s(row.legaDa))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-center pa-2",
                                  attrs: { width: "100" },
                                },
                                [_c("b", [_vm._v(_vm._s(row.prezzo))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "text-left text--text text--lighten-2 pa-2",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(row.comment) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1931478419
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }